<template>
  <LvDropdownSingleCategorySelect
    :value="value"
    outline
    :rules="rules"
    :label="label"
    :title="title"
    :scope="_guidelineStatusScope"
    :menuItems="list"
    :scroll="scrollTop"
    :required="required"
    :createUrl="_createUrl"
    :isDeletable="isItemDeletable"
    :isLoadingItems="isLoading.list"
    :createFields="_guidelineStatus.createFields"
    :updateFields="_guidelineStatus.updateFields"
    :setDeletePopupInfo="_guidelineStatus.setDeletePopupInfo"
    @created="$_getList"
    @delete="$_onDelete($event)"
    @update="$_onUpdate($event)"
    @input="$emit('input', $event)"
    @active-delete-popup="$_getDeletePopupInfo"
  />
</template>

<script>
import S_guidelineStatus from '@/service/api/v1/guidelineStatus';
import H_guidelineStatus from '@/helpers/guidelineStatus';
import Spare_guidelineStatus from '@/spare/guidelineStatus';

export default {
  props: {
    title: {
      type: String,
    },
    label: {
      type: String,
    },
    scrollTop: {
      type: [Number, String],
    },
    value: {
      type: String,
    },
    isCreatable: {
      type: Boolean,
      default: false,
    },
    isUpdatable: {
      type: Boolean,
      default: false,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
    },
    setUpdateItem: {
      type: Function,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
    }
  },
  data() {
    return {
      isLoading: {
        list: false,
      },
      list: [{
          title: '',
          menu: [],
          isCustom: false,
      }],
      isItemDeletable: false,
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _guidelineStatusScope() {
      return {
        isCreatable: this.isCreatable,
        isUpdatable: this.isUpdatable,
        isDeletable: this.isDeletable,
      };
    },
    _createUrl() {
      return `factory/${this._currentFactoryId}/guideline_status`;
    },
    _guidelineStatus() {
      return {
        createFields: Spare_guidelineStatus.createFields,
        updateFields: Spare_guidelineStatus.updateFields,
        setDeletePopupInfo: async (data) => await H_guidelineStatus.setDeletePopupInfo(data),
        getList: S_guidelineStatus.index,
        setList: H_guidelineStatus.setDropdownCustomItems,
        deleteItem: S_guidelineStatus.delete,
        updateItem: S_guidelineStatus.update,
      };
    },
  },
  watch: {
    'isLoading.list': {
      handler() {
        this.$emit('loading', this.isLoading.list);
      }
    }
  },
  async mounted() {
    await this.$_getList();
  },
  methods: {
    async $_getList() {
      if (!this._guidelineStatus.getList) return;
      this.isLoading.list = true;
      const params = this.params
        ? this.params
        : {
          order_by: "sequence",
          order_way: "asc",
          get_all: 1,
        };
      const res = await this._guidelineStatus.getList(params);
      this.list = this._guidelineStatus.setList ? this._guidelineStatus.setList(res) : res;
      this.isLoading.list = false;
    },
    async $_onDelete($event) {
      if (!this._guidelineStatus.deleteItem) return;
      const {value: id} = $event;
      await this._guidelineStatus.deleteItem(id);
      await this.$_getList();
    },
    async $_onUpdate($event) {
      if (!this._guidelineStatus.updateItem) return;
      const {value: id, name, sequence} = $event;
      const data = this.setUpdateItem
        ? this.setUpdateItem($event)
        :  {
            name,
            sequence,
          };
      await this._guidelineStatus.updateItem(id, data);
      await this.$_getList();
    },
    $_getDeletePopupInfo($event) {
      const {deletePopup} = $event;
      const {relatedModuleNumList} = deletePopup;
      this.isItemDeletable = relatedModuleNumList.length === 0;
    }
  }
}
</script>